"use client";
import { j as l } from "./index.es9.js";
import { forwardRef as b, useMemo as p } from "react";
import { makeUniqueId as h, composeClassNames as u } from "./index.es88.js";
import f from "./index.es89.js";
const v = b(
  ({
    children: n,
    state: e,
    message: s,
    isDisabled: c = !1,
    label: o = null,
    name: r = null,
    onChange: m = null,
    inputId: a,
    ...t
  }, d) => {
    const i = p(() => h(), []);
    return /* @__PURE__ */ l.jsxs("div", { className: "bl-select", children: [
      /* @__PURE__ */ l.jsx(
        "label",
        {
          className: "bl-select__label bl-size-6 bl-display-block bl-p-b-1",
          htmlFor: a || i,
          children: o
        }
      ),
      /* @__PURE__ */ l.jsxs("div", { className: "bl-select__icon-wrapper", children: [
        /* @__PURE__ */ l.jsx("i", { className: "bl-select__icon bl-icon--chevron-down bl-icon--small" }),
        /* @__PURE__ */ l.jsx(
          "select",
          {
            ...t,
            ref: d,
            id: a || i,
            name: r,
            disabled: c,
            className: u(
              "bl-input",
              e && `bl-input--${e}`
            ),
            onChange: m,
            children: n
          }
        )
      ] }),
      s && /* @__PURE__ */ l.jsx("div", { className: "bl-p-t-1", children: /* @__PURE__ */ l.jsx(f, { state: e, children: s }) })
    ] });
  }
);
export {
  v as default
};
//# sourceMappingURL=index.es15.js.map
